import { createAtomObserver } from '@exodus/atoms';
const createAssetSourcesLifecyclePlugin = ({ port, availableAssetNamesByWalletAccountAtom, }) => {
    const observer = createAtomObserver({
        port,
        atom: availableAssetNamesByWalletAccountAtom,
        event: 'availableAssetNamesByWalletAccount',
        immediateRegister: false,
    });
    const onStart = () => {
        observer.register();
    };
    const onLoad = () => {
        void observer.start();
    };
    const onStop = () => {
        observer.unregister();
    };
    return { onLoad, onStart, onStop };
};
const AssetSourcesLifecyclePluginDefinition = {
    id: 'assetSourcesLifecyclePlugin',
    type: 'plugin',
    factory: createAssetSourcesLifecyclePlugin,
    dependencies: ['port', 'availableAssetNamesByWalletAccountAtom'],
    public: true,
};
export default AssetSourcesLifecyclePluginDefinition;
